import { motion } from "framer-motion";
import { useT } from "../lang";

const T = {
  pt: {
    label: "06 · contato",
    h1: "BORA",
    h2: "CONVERSAR?",
    videoTop: "✷ off the record",
    videoTitle: "bring me · brasil",
    intro:
      "Se você procura estratégia criativa, campanhas com influenciadores e conteúdo que conecta marcas, pessoas e comunidades, vamos conversar. ⭐",
  },
  en: {
    label: "06 · contact",
    h1: "LET'S",
    h2: "TALK.",
    videoTop: "✷ off the record",
    videoTitle: "bring me · brazil",
    intro:
      "If you're looking for creative strategy, influencer campaigns, and content that connects brands, people, and communities — let's talk. ⭐",
  },
};

const contacts = [
  { k: "email", v: "hello@gabiferraz.co", href: "mailto:hello@gabiferraz.co" },
  {
    k: "linkedin",
    v: "hello-gabrielaferraz",
    href: "https://www.linkedin.com/in/hello-gabrielaferraz/",
  },
  { k: "phone", v: "+1 (914) 500-5312", href: "tel:+19145005312" },
];

export default function Contact() {
  const t = useT(T);
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32"
    >
      <div className="container-wide">
        <div className="flex items-center gap-3 mb-10">
          <span className="label">{t.label}</span>
          <span className="text-2xl">☺</span>
        </div>

        <div className="grid grid-cols-12 gap-8 md:gap-10 mb-14 items-end">
          <motion.h2
            initial={{ opacity: 0, y: 24 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.3 }}
            transition={{ duration: 0.9 }}
            className="col-span-12 md:col-span-7 font-display uppercase text-[12vw] md:text-[5.5vw] leading-[0.9] tracking-[-0.02em]"
          >
            <span className="text-brick">{t.h1}</span>
            <br />
            {t.h2}
          </motion.h2>
          <div className="col-span-12 md:col-span-5 flex flex-col gap-4">
            <div
              className="border border-[color:var(--ink)] overflow-hidden bg-ink"
              data-testid="contact-video-wrap"
            >
              <div className="flex items-center justify-between px-3 py-2 border-b border-[color:var(--ink)] label !text-off bg-ink">
                <span className="!text-off/85">{t.videoTop}</span>
                <span className="!text-off/85">{t.videoTitle}</span>
              </div>
              <video
                autoPlay
                loop
                muted
                playsInline
                preload="metadata"
                className="w-full h-auto block bg-black"
                data-testid="contact-video"
              >
                <source src="/contact-video.webm" type="video/webm" />
                <source src="/contact-video.mp4" type="video/mp4" />
              </video>
            </div>
            <p className="font-body text-sm md:text-base leading-relaxed text-[color:var(--ink)]/85">
              {t.intro}
            </p>
          </div>
        </div>

        <div className="max-w-[880px]" data-testid="contact-list">
          {contacts.map((c, i) => (
            <motion.a
              key={c.k}
              href={c.href}
              target={
                c.href.startsWith("mailto:") || c.href.startsWith("tel:")
                  ? undefined
                  : "_blank"
              }
              rel="noreferrer"
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.4 }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="crow"
              data-testid={`contact-${c.k}`}
            >
              <span className="label">{c.k}</span>
              <span className="font-display uppercase text-xl md:text-3xl">
                {c.v}
              </span>
              <span className="crow-arrow font-narrow text-xl">↗</span>
            </motion.a>
          ))}
        </div>
      </div>
    </section>
  );
}
